import moment from "moment";

const YEAR_2000_MILLIS = Date.parse('2000-01-01').valueOf();
export default class DateUtils {
    static getDateString = millis => millis < YEAR_2000_MILLIS ? '' : moment(millis).format('yyyy-MM-DD')
    static get1972DateString = () => '1972-01-01';
}